import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { config } from './config';
import { App } from './App'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // refetchOnWindowFocus: !!config.REFETCH_ON_FOCUS,
    },
  },
});

export const Entry = () => (
  <QueryClientProvider client={queryClient}>
    {config.ENV === 'development' && (
      <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
    )}
    <App />
  </QueryClientProvider>
);
